// extracted by mini-css-extract-plugin
export default {"imageWrapper":"HE-z","hovered":"IE-z","hoverImage":"JE-z","mainImage":"KE-z","imageNoBackground":"LE-z","fullSizeImage":"ME-z"};